import { api } from './auth.service';

const negocioAnexoService = {

  listar: async (negocioId) => {
    const res = await api.get(`/anexos/negocio/${negocioId}`);
    return res.data;
  },

  // Upload — recebe File + descrição + flag de exibir na timeline
  // Tudo vai junto no FormData pro backend criar o anexo + evento na
  // mesma transação.
  upload: async (negocioId, file, descricao, exibirTimeline, dataExibicao, onProgress) => {
    const formData = new FormData();
    formData.append('arquivo', file);
    formData.append('descricao', descricao || '');
    formData.append('exibir_timeline', exibirTimeline ? 'true' : 'false');
    formData.append('data_exibicao', dataExibicao || '');

    const res = await api.post(`/anexos/negocio/${negocioId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => {
        if (onProgress && evt.total) {
          onProgress(Math.round((evt.loaded * 100) / evt.total));
        }
      },
    });
    return res.data;
  },

  // Baixa o arquivo via fetch (pra poder incluir o token JWT)
  download: async (negocioId, anexoId, nomeArquivo) => {
    const res = await api.get(`/anexos/negocio/${negocioId}/${anexoId}/download`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Exclui o anexo. Body opcional:
  //   { excluir_quantificacao: true } → quando o anexo é DOS010 vinculado
  //   à versão MAIOR de quantificação, apaga também a quantificação e rebaixa
  //   a versão ativa do negócio. Backend valida a regra de segurança
  //   (só apaga se for mesmo a versão maior).
  excluir: async (negocioId, anexoId, opts = {}) => {
    const res = await api.delete(`/anexos/negocio/${negocioId}/${anexoId}`, {
      data: opts || {},
    });
    return res.data;
  },
};

export default negocioAnexoService;
